<template>
  <div class="brandZone">
    <div class="top_swiper">
      <!-- <van-swipe :autoplay="3000">
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <img v-lazy="image" />
        </van-swipe-item>
      </van-swipe>-->
      <img :src="img" alt class="van-swipe-img" />
      <div class="goods_list">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="goods_content" v-for="item in list" :key="item.id">
            <div
              class="flex"
              @click="goBannerDetails({...item, goods_id: item.id, page_type: 'goods_detail'})"
            >
              <img :src="item.images" alt />
              <div class="goods_right">
                <div class="goods_title">{{item.goods_name}}</div>
                <div class="goods_price flex">
                  <p class="price">
                    ¥
                    <span>{{item.price}}</span>
                  </p>
                </div>
                <div class="flex nums">
                  <p class="delete_line">¥{{item.market_price}}</p>
                  <p>销量：{{item.sales}}</p>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        'https://img01.yzcdn.cn/vant/apple-1.jpg',
        'https://img01.yzcdn.cn/vant/apple-2.jpg',
      ],
      id: '',
      list: [],
      loading: false,
      finished: false,
      page: 0,
      img: '',
    }
  },
  created() {
    this.id = this.$route.query.id
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    onLoad() {
      this.page++
      this.getGoodsListByBrandId()
    },
    getGoodsListByBrandId() {
      this.http('ClientGoods.goodsListByBrandId', {
        brand_id: this.id,
        page: this.page,
        limit: 20,
      }).then((e) => {
        this.img = e.content.brand_image_url
        this.list = [...this.list, ...e.content.list]
        this.finished = this.list.length == e.content.count
        console.log(e)
      })
    },
    //跳转商品详情
    goBannerDetails(item) {
      console.log(item)
      if (item.goods_activity_batch_details_id) {
        this.goActDetails(item.goods_activity_batch_details_id)
      } else if (item.page_type == 'goods_detail') {
        this.$router.push({
          path: '/shopDetails',
          query: { goods_id: item.goods_id },
        })
      } else {
        window.location.href = item.url
      }
    },
  },
}
</script>

<style scoped lang="scss">
.brandZone {
  background: rgba(247, 248, 250, 1);
}
.top_swiper {
  width: 750px;
  height: 360px;
  padding: 20px 0;
  background: url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/yijiu_blur.png')
    no-repeat center;
  background-size: 100% 414px;
}

.van-swipe-img {
  width: 710px;
  height: 340px;
  display: block;
  margin: 0 auto;
}
img {
  width: 100%;
  height: 100%;
}
.goods_list {
  background: #f7f8fa;
  padding: 0 20px;
  margin-top: 20px;
  .goods_content {
    padding: 24px 30px;
    background: #ffffff;
    border-radius: 20px;
    margin-bottom: 20px;
    .flex {
      img {
        width: 160px;
        height: 160px;
      }
      .goods_right {
        margin-left: 30px;
        .goods_title {
          font-size: 28px;
          color: #2c2d42;
          font-weight: 700;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .goods_price {
          align-items: center;
          padding: 16px 0 10px 0;
          .price {
            font-size: 24px;
            color: #ee0a24;
          }
          .goods_sales {
            width: 220px;
            height: 34px;
            border-radius: 10px;
            border: 1px solid #ee0a24;
            margin-left: 18px;
            .goods_num {
              width: 70px;
              text-align: center;
              font-size: 24px;
              color: #ffffff;
              background: #ee0a24;
              border-radius: 10px;
            }
            .goods_comit {
              font-size: 24px;
              color: #ee0a24;
              text-align: center;
              padding-left: 16px;
            }
          }
        }
        .nums {
          font-size: 24px;
          color: #c0c0c0;
          justify-content: space-between;
          .delete_line {
            text-decoration: line-through;
          }
        }
      }
    }
  }
}
</style>